import { TFunction } from 'i18next';
import { z } from 'zod';

import { getColorValidation, getGeneralBuilderSchema } from '~/utils/validation/qrCodeBuilder';
import { getUrlZodValidation } from '~/utils/validation/url';

export const getVideoQRSchema = ({ t, qrCodeUri }: { t: TFunction; qrCodeUri?: string }) =>
  z
    .object({
      appearance: z.object({
        design: z.object({
          primary: getColorValidation({ t }),
        }),
        fonts: z.object({
          title: z.string(),
          text: z.string(),
          titleColor: getColorValidation({ t }),
          textsColor: getColorValidation({ t }),
        }),
      }),
      basicInfo: z.object({
        video: z.object({
          videoUrl: getUrlZodValidation({ t, isRequired: false }).optional(),
          showVideoDirectly: z.boolean(),
          files: z.array(
            z.object({
              id: z.number().optional(),
              videoFileId: z.string().optional(),
              thumbnailId: z.string().optional(),
              sourceType: z.enum(['SELF_HOSTED', 'YOUTUBE'] as const),
              sourceUrl: z.string().optional(),
              thumbnail: z.string().optional(),
              displayOrder: z.number(),
              description: z.string().optional(),
              videoFile: z.string(),
            }),
          ),
        }),
        information: z.object({
          company: z.string().optional(),
          videoTitle: z.string().optional(),
          description: z.string().optional(),
          buttonText: z.string().optional(),
          buttonURL: getUrlZodValidation({ t }).optional(),
        }),
      }),
    })
    .merge(getGeneralBuilderSchema({ t, prevQRCodeURLFromResponse: qrCodeUri }));

const videoQRSchema = getVideoQRSchema({ t: (() => {}) as TFunction });
export type VideoQRSchema = z.infer<typeof videoQRSchema>;
